import { Card, CardBody, Col, Container, Input, Label, Row, Table } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { SearchTableButton } from "../../utils/Constant";
import Breadcrumbs from "../../CommonElements/Breadcrumbs/Breadcrumbs";
import SweetAlert from 'sweetalert2';
import { useEffect, useState } from "react";
import useFourListe, { changeStatus, deleteProduit } from "../Produits/produitsApi";
import { formatPrice } from "../../utils/helper/helpers";
import '../../utils/helper/style.css';
import { useAppDispatch } from "../../ReduxToolkit/Hooks";
import { ProductItemInterface } from "../../Type/Application/Ecommerce/Product";
import { addToCartData } from "../../ReduxToolkit/Reducers/CartSlice";
import CartContainer from "../../Component/Application/Ecommerce/Cart/Cart"

type Produit = { [key: string]: any }

const GestVentes = () => {

    const [filterText, setFilterText] = useState("");
    const [filteredItems, setFilteredItems] = useState<Produit[]>([]);
    const [refresh, setRefresh] = useState(false);
    const prods = useFourListe(refresh) || [];
    const dispatch = useAppDispatch();

    useEffect(() => {
        const filtered = prods.filter((item) =>
            item.libelle && item.libelle.toLowerCase().includes(filterText.toLowerCase())
        );

        if (JSON.stringify(filtered) !== JSON.stringify(filteredItems)) {
            setFilteredItems(filtered);
        }
    }, [prods, filterText, filteredItems, refresh]);

    const Confirmation = ({ id, type }: { id: number, type: string }) => {
        SweetAlert.fire({
            title: 'Êtes-vous sûr?',
            text: type == 'supprimer' ? "De Vouloir Supprimer cet element ??" : "De vouloir changer le status de cet element",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: type == 'supprimer' ? 'Oui, Supprimer !' : 'Oui, Changer'
        }).then((result) => {
            if (result.isConfirmed) {
                type == 'supprimer' ? deleteProduit({ id: id }, () => setRefresh(!refresh)) : changeStatus({ id: id }, () => setRefresh(!refresh));
            }
        });
    };

    const AddToCarts = (item: ProductItemInterface, quantity: number) => {
        dispatch(addToCartData({ item, quantity }));
    };

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Espace de vente" parent="Gestions" />
            <Container fluid>
                <Row>
                    <Col md="6">
                        <CartContainer />
                    </Col>
                    <Col md="6">
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm="12">
                                        <div className="dataTables_filter d-flex align-items-center">
                                            <Label className="me-2">{SearchTableButton}:</Label>
                                            <Input
                                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFilterText(e.target.value)}
                                                type="search"
                                                value={filterText}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>

                            <Table responsive id="all-invoice">
                                <thead className="bg-info">
                                    <tr>
                                        <th className="text-white">Id</th>
                                        <th className="text-white ps-4">Libelle</th>
                                        <th className="text-white ">Prix Unitaire</th>
                                        <th className="text-white ">Nbr Ventes</th>
                                        <th className="text-white ">Quantite</th>
                                        <th className="text-white ">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredItems.map((item, index) => {
                                        if (item.quantite_stock > 0 && item.status !== 'inactif') {
                                            return (
                                                <tr key={item.id} className='text-center'>
                                                    <th scope='row'>
                                                        <span className="fw-bold">
                                                            #{index + 1}
                                                        </span>
                                                    </th>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className="fw-bold text-capitalize">
                                                            {item.libelle}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className="fw-bold text-capitalize">
                                                            {formatPrice(item.prix_unitaire)}
                                                        </span>
                                                    </td>
                                                    <td style={{ textAlign: "center" }}>
                                                        <span className="fw-bold text-capitalize">
                                                            {parseInt(item.vente_count).toLocaleString("gn-GN")}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {item.quantite_stock <= 10 ? (
                                                            <Btn className="btn btn-xs btn-light-danger" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                {parseFloat(item.quantite_stock).toLocaleString("gn-GN")}
                                                            </Btn>
                                                        ) : (
                                                            <Btn className="btn btn-xs btn-light-success" onClick={() => Confirmation({ id: item.id, type: "changeStatus" })}>
                                                                {parseFloat(item.quantite_stock).toLocaleString("gn-GN")}
                                                            </Btn>
                                                        )}
                                                    </td>
                                                    <td>
                                                        <Btn className='bg-dark btn-xs mx-1 my-1' onClick={() => AddToCarts(item as ProductItemInterface, 0.5)}>
                                                            <i className='fa fa-shopping-basket'></i>
                                                        </Btn>
                                                    </td>
                                                </tr>
                                            )
                                        } return null;
                                    })}
                                </tbody>
                            </Table>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </div>

    )
}

export default GestVentes